<template>
  <v-container fluid>
    <v-form ref="form" v-model="form" @submit.prevent="submit">
      <v-row>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-if="!operation.is_draft">
          <v-switch
            dense
            hide-details
            v-model="serviceOptFormClass.metadata.arrange_by_owner"
            label="Arrange By Principal?"
            class="mt-0 pt-0"
          ></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!serviceOptFormClass.metadata.arrange_by_owner" v-if="$root.hasAccess('can_manage_operation_amount_details')">
          <v-text-field
            label="Class Surveyor Charges"
            placeholder="Enter Class Surveyor Charges"
            :rules="amountRules"
            outlined
            dense
            type="number"
            v-model="serviceOptFormClass.amount"
            prepend-inner-icon="mdi-currency-usd"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!serviceOptFormClass.metadata.arrange_by_owner">
          <v-select
            label="Class Surveyor Supplier"
            placeholder="Select Class Surveyor supplier"
            outlined
            dense
            v-model="serviceOptFormClass.card_id"
            prepend-inner-icon="mdi-account"
            :items="suppliersList"
            :rules="supplierRules"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!serviceOptFormClass.metadata.arrange_by_owner" v-if="$root.hasAccess('can_manage_operation_amount_details')">
          <v-select
            label="Tax"
            placeholder="Select Tax"
            outlined
            dense
            v-model="serviceOptFormClass.metadata.tax"
            prepend-inner-icon="mdi-cash-fast"
            :items="taxes"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-textarea
            label="Remarks"
            placeholder="Enter Remarks"
            outlined
            dense
            hide-details
            :rows="2"
            v-model="serviceOptFormClass.remarks"
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="pb-0" v-if="$root.onlyAccountsCanAccess">
          <v-textarea
            label="Accounts Remarks"
            placeholder="Enter Accounts Remarks"
            outlined
            background-color="light-blue lighten-5"
            dense
            hide-details
            :rows="2"
            v-model="serviceOptFormClass.accounts_remarks"
            class="accounts-remarks-field"
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-btn class="float-right" color="success" outlined :disabled="loading" :loading="loading"
            @click="saveDetails">Save</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
  import rules from '../../../../utilities/validator';
  import _ from 'lodash';

  export default {
    name: 's-services-opted-surveyor',
    props: {
      operation: {
        type: Object,
        default: {},
      },
      isDraft: {
        type: Boolean,
        default: false,
      },
      servicesOpted: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        loading: false,
        form: false,
        rules,
        serviceOptFormClass: {
          service_catalog_id: null,
          card_id: null,
          amount: 0,
          bill_type: 'Class Surveyor',
          metadata: {
            arrange_by_owner: false,
            tax: ''
          },
          remarks: '',
          accounts_remarks: '',
        },
        suppliersList: [],
        taxes: ['0%', '9%']
      };
    },
    methods: {
      submit() {
        return this.$refs.form.validate();
      },
      handleOperationInit() {
        this.populateSuppliers();
      },
      initServiceOptedDetails() {
        const classService = _.find(this.servicesOpted, {bill_type: 'Class Surveyor'});
        if (classService) {
          this.serviceOptFormClass = {
            ...classService,
            amount: classService.amount ? parseFloat(classService.amount).toFixed(2) : 0,
          };
          if (classService.metadata && classService.metadata.arrange_by_owner !== undefined) {
            this.serviceOptFormClass.metadata.arrange_by_owner = classService.metadata.arrange_by_owner;
          }
        }
      },
      populateSuppliers() {
        this.$api.service_catalogs.get_suppliers_list('Class Surveyor')
          .then((response) => {
            this.suppliersList = response.suppliers;
            this.serviceOptFormClass.service_catalog_id = response.service_catalog_id;
            this.initServiceOptedDetails();
          }).catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          });
      },
      saveDetails() {
        if(!this.submit()) return;
        this.loading = true;
        this.serviceOptFormClass = Object.assign(this.serviceOptFormClass, {
          operation_id: this.operation.id
        });

        Promise.all([
            this.$api.operation_billed_items.save_service(this.serviceOptFormClass)
          ]).then(() => {
            this.$store.dispatch('setAlert', {
              status: 'success',
              show: true,
              message: 'Surveyor service updated successfully',
            });
          }).catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          }).finally(() => (this.loading = false));
      }
    },
    watch: {
      operation(value) {
        this.handleOperationInit();
      }
    },
    computed: {
      amountRules() {
        if (this.serviceOptFormClass.metadata.arrange_by_owner) {
          return [this.rules.negative];
        } else {
          if (this.isDraft || (this.operation && this.operation.is_draft)) {
            return [this.rules.required, this.rules.negative];
          } else {
            return [this.rules.negative];
          }
        }
      },
      supplierRules() {
        if (this.serviceOptFormClass.metadata.arrange_by_owner) {
          return [];
        } else {
          return [this.rules.required];
        }
      },
    },
    created() {
      this.handleOperationInit();
    },
  };
</script>